import React from 'react';

const UntickIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M 7 12 H 16 Z" fill="transparent" stroke="#ccc" strokeWidth="1" />
    </svg>
);
    

export default UntickIcon;




// WEBPACK FOOTER //
// ./src/components/Icons/UntickIcon.js